import { Constructor } from '@/type-utils';
import { mocked } from '@/configs';
import { noop } from '@/utils/function-utils';
import type { IBuilderContentData } from './schemas/IBuilderContentData';
import MockService, { MockState, ServiceMock } from '../../MockService';
import type { BuilderService } from './BuilderService';
import { MOCK_BUILDER_CONTENT } from './mocks/MOCK_BUILDER_CONTENT';
import { ModelTarget } from './schemas';

const initialState = {};

/**
 * Mock for the BuilderService.
 */
export default class BuilderServiceMock extends ServiceMock<BuilderService> {
  protected _state;

  /** @inheritdoc */
  public get state(): MockState {
    return this._state;
  }

  /** @inheritdoc */
  public getMock(): BuilderService {
    return MockService.getMockOf(this.service) as unknown as BuilderService;
  }

  /**
   * The constructor to initialize the mocks.
   * @param service - The service that is being mocked.
   */
  public constructor(private service: Constructor<BuilderService>) {
    super();
    this._state = new MockState(initialState);
    this.initializeMockedMembers(service);
  }

  /** @inheritdoc */
  protected initializeMockedMembers(
    service: Constructor<BuilderService>
  ): void {
    const mockEnabled: boolean = mocked.ContentService;

    MockService.mockService(
      mockEnabled,
      service,
      {
        // Keep signature aligned with real service (void)
        initBuilder: noop,
        // Use the mock content's type instead of non-existent DataModelTarget.Page
        getBuilderContentTarget: () => 'page',
        getContentByModel: async (): Promise<IBuilderContentData> => {
          return {
            ...MOCK_BUILDER_CONTENT,
            service: 'builder',
            type: ModelTarget.PageModel
          } as unknown as IBuilderContentData;
        }
      } as Partial<BuilderService>,
      {},
      this.state
    );
  }
}
